module.exports = __webpack_public_path__ + "img/carto-logo-negative.de424c51.svg";